/**
 * Project : workspace
 * File    : ScreenDimension.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package component.dimension

import androidx.compose.ui.unit.Dp
import navigation.AppNavigator

/**
 * Represents the screen dimension class.
 */

class ScreenDimension {
    fun width(percent: String) {

    }

    /**
 * Executes the height operation.
 *
 * @receiver TODO
 * @param percent The percent.
 * @return Unit – no return value.
 */

    fun height(percent: String) {

    }

    /**
 * Executes the width operation.
 *
 * @receiver TODO
 * @param multiplier The multiplier.
 * @return The resulting dp.
 */

    fun width(multiplier: Float): Dp {
        return AppNavigator.shared().screenWidth * multiplier
    }

    /**
 * Executes the height operation.
 *
 * @receiver TODO
 * @param multiplier The multiplier.
 * @return The resulting dp.
 */

    fun height(multiplier: Float): Dp {
        return AppNavigator.shared().screenHeight * multiplier
    }

    /**
 * Executes the width half operation.
 *
 * @receiver TODO
 * @return The resulting float.
 */

    fun widthHalf(): Float {
        return AppNavigator.shared().screenWidth.value * 0.5F
    }

    /**
 * Executes the height half operation.
 *
 * @receiver TODO
 * @return The resulting float.
 */

    fun heightHalf(): Float {
        return AppNavigator.shared().screenHeight.value * 0.5f
    }

    /**
 * Executes the width operation.
 *
 * @receiver TODO
 * @return The resulting dp.
 */

    fun width(): Dp {
        return AppNavigator.shared().screenWidth
    }

    /**
 * Executes the height operation.
 *
 * @receiver TODO
 * @return The resulting dp.
 */

    fun height(): Dp {
        return AppNavigator.shared().screenHeight
    }


}